import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';

class Component extends BaseComponent {
    link_index = 0;

    get_breadcrumb_link(links) {
        let length = links.length;
        // First one will be `/articles`
        if (this.link_index == 0) {
            // Find /articles
            for (var i = this.link_index; i < length; i++) {
                if (links[i].endsWith('/articles')) {
                    this.link_index = i + 1;
                    return links[i];
                }
            }
        }
        // get the next on that is not the bio link
        for (var j = this.link_index; j < length; j++) {
            if  (! links[j].includes('/bios/')) {
                this.link_index = j + 1;
                return links[j];
            }
        }
        return '';
    }

    render({ breadcrumb, links, url_path_dir1, url_path_dir2, trackClick }) {
        this.link_index = 0;
        if (breadcrumb) {
            const crumbs = breadcrumb.raw.split('>').map(item => item.trim());
            const breadcrumb_links = crumbs.map((crumb) =>
                <a
                    dangerouslySetInnerHTML={{
                        __html: crumb,
                    }}
                    data-label={'Breadcrumb:' + crumb}
                    href={this.get_breadcrumb_link(links.raw)}
                    onClick={trackClick}
                    target='_blank'
                />
            );
            return (
                <li className='sui-result__value breadcrumb has-padding-15-left-mobile has-padding-15-right-mobile'>
                    {breadcrumb_links.map((bl, i) => [
                        i > 0 && <span className='has-margin-10-left has-margin-10-right'>&gt;</span>,
                        bl,
                    ])}
                </li>

            );
        } else if (url_path_dir1) {
            let second_path = null;
            if (url_path_dir2) {
                second_path = url_path_dir2.replace(/(-reports|-readings)$/, '').replace(/i-ching$/, 'iching');
            }
            return(
                <li className='breadcrumb has-padding-15-left-mobile has-padding-15-right-mobile'>
                    <a
                        data-label='Breadcrumb'
                        href='/articles'
                        onClick={trackClick}
                        target='_blank'
                    >
                    EXPLORE TAROT.COM
                    </a>
                    <span className='has-margin-10-left has-margin-10-right'>&gt;</span>
                    <a
                        dangerouslySetInnerHTML={{
                            __html: url_path_dir1.toUpperCase().replace(/-/, ' '),
                        }}
                        data-label='Breadcrumb'
                        href={url_path_dir1}
                        onClick={trackClick}
                        target='_blank'
                    />
                    { second_path && <span className='has-margin-10-left has-margin-10-right'>&gt;</span>}
                    { second_path &&
                        <a
                            dangerouslySetInnerHTML={{
                                __html: url_path_dir2.toUpperCase().replace(/-/, ' '),
                            }}
                            data-label='Breadcrumb'
                            href={`${url_path_dir1}/${second_path}`}
                            onClick={trackClick}
                            target='_blank'
                        />
                    }
                </li>
            );
        }
        return '';
    }
}

export default connect()(Component);
